module.exports = __webpack_public_path__ + "img/1.b48a649e.png";